import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonComponent from 'components/Button';
import { fetchAdicionarJustificativa, fetchRetornarParaAtendente } from 'store/fetchActions/fetchFormulario';
import { fetchSalvarArquivos } from 'store/fetchActions/fetchArquivo';
import { fetchGetTodosStatus } from 'store/fetchActions/fetchInputForm';
import { MSG_CAMPO_OBRIGATORIO, STATUS_REQUERIMENTO } from 'utils/consts';
import { formatterFileFrontToBack } from 'utils/formatter/arquivos';
import { formatterJustificativaFrontToBack } from 'utils/formatter/justificativa';

export const ButtonModalContribuinte = ({
  setExibirLoading,
  sucessoFinalizar,
  valueJustificativa,
  arquivos,
  setError,
}) => {
  const dispatch = useDispatch();

  const dadosDetalhar = useSelector(state => state.formulario.dadosExibirDetalhar);
  const listaStatus = useSelector(state => state.status.todosStatus);

  const validarCampo = justificativa => {
    if (!justificativa) {
      setError('justificativa', { type: 'Custom', message: MSG_CAMPO_OBRIGATORIO });
      return false;
    }
    return true;
  };

  const handleRetornarAtendente = () => {
    dispatch(fetchGetTodosStatus(listaStatus))
      .then(todosStatus => {
        const status = todosStatus.find(x => x.identificador === STATUS_REQUERIMENTO.REATENDIMENTO.identificador);
        dispatch(fetchRetornarParaAtendente(dadosDetalhar?.id, status?.id))
          .then(res => sucessoFinalizar(res))
          .catch(() => setExibirLoading(false))
          .finally(() => setExibirLoading(false));
      })
      .catch(() => setExibirLoading(false));
  };

  async function salvarJustificativa(novoStatusId) {
    if (!validarCampo(valueJustificativa)) return;
    setExibirLoading(true);
    const arquivosFormatados = await formatterFileFrontToBack(arquivos, {
      id: dadosDetalhar?.id,
      localizador: dadosDetalhar?.localizador,
    });
    const justificativaFormatada = formatterJustificativaFrontToBack(
      valueJustificativa,
      dadosDetalhar?.id,
      null,
      false,
      novoStatusId
    );

    dispatch(fetchAdicionarJustificativa(justificativaFormatada))
      .then(() => {
        dispatch(fetchSalvarArquivos(arquivosFormatados))
          .then(() => handleRetornarAtendente())
          .catch(() => setExibirLoading(false));
      })
      .catch(() => setExibirLoading(false));
  }

  return (
    <ButtonComponent
      text={'Finalizar Edição'}
      clickAction={() => salvarJustificativa(STATUS_REQUERIMENTO.REATENDIMENTO.id)}
      css={{ margin: '50px 0px 5px 5px' }}
    />
  );
};

export default ButtonModalContribuinte;
